export default {
  assignedChats: [],
  todayChats: []
};
